import { call, put } from "redux-saga/effects"
import errorHandler from 'src/utils/handler'
import { notifications } from "@mantine/notifications"
import { ReactComponent as IconError } from 'src/assets/icons/toast-error.svg'
import { ReactComponent as IconSuccess } from 'src/assets/icons/toast-success.svg'
import React from "react"
import { capitalizeFirstLetter } from "src/utils"
import { setUserDetails } from "src/features/account/accountSlice"
import { requestUploadPersonalDetails, requestDocumentUpload } from "./modificationRequests"
import {
  uploadDocumentSuccess,
  uploadDocumentFailure,
  uploadPersonalDetailsSuccess,
  uploadPersonalDetailsFailure,
} from "./modificationSlice"
import type { UploadPersonalDetailsAction, UploadDocumentAction } from "./types"

export function* handleUploadDocument(action:UploadDocumentAction): Generator<any, any, any> {
  const incomeDocDetails = action.payload
  try {
    const response = yield call(requestDocumentUpload, {
      data: incomeDocDetails.data,
      step: incomeDocDetails.step,
      document_type: incomeDocDetails.document_type,
      password: incomeDocDetails.password || '',
    })
    const { data, status } = response
    yield put(uploadDocumentSuccess({ data, loading: false, status }))
    if (status === 200) {
      notifications.show({
        color: 'green',
        message: 'Document uploaded successfully!',
        icon: React.createElement(IconSuccess, null),
      });
    }
    yield put(setUserDetails(data.user));
  } catch (error) {
    yield put(uploadDocumentFailure({
      error: errorHandler(error).message,
      status: errorHandler(error).status,
      isError: true,
      data: { step: incomeDocDetails.step },
    }))
    notifications.show({
      color: 'red',
      message: capitalizeFirstLetter(errorHandler(error).message),
      icon: React.createElement(IconError, null),
    });
  }
}

export function* handleUploadPersonalDetails(action:UploadPersonalDetailsAction): Generator<any, any, any> {
  try {
    // @ts-ignore
    const response = yield call(requestUploadPersonalDetails, { ...action.payload, segments: ["NSE_FO"] })
    const { data, status } = response
    yield put(uploadPersonalDetailsSuccess({ data, loading: false, status }))
    yield put(setUserDetails(data.user));
    if (status === 200) {
      notifications.show({
        color: 'green',
        message: 'Details uploaded successfully!',
        icon: React.createElement(IconSuccess, null),
      });
    }
  } catch (error) {
    yield put(uploadPersonalDetailsFailure({
      error: errorHandler(error).message,
      status: errorHandler(error).status,
      isError: true,
    }))
    notifications.show({
      color: 'red',
      message: capitalizeFirstLetter(errorHandler(error).message),
      icon: React.createElement(IconError, null),
    });
  }
}
